// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width:3020px){img[data-v-08983b8f]{height:96px}}img.bottom-right[data-v-08983b8f]{bottom:1rem;height:auto;max-height:64px;max-width:calc(100vw - 5rem);position:absolute;right:1rem}@media(min-width:576px){img.bottom-right[data-v-08983b8f]{left:1rem;margin-left:auto;margin-right:auto}}@media(min-width:3020px){img.bottom-right[data-v-08983b8f]{max-height:96px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
